var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvChromecastStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 1C0.598 1 0 1.6279 0 2.4V5.2H1.33333V2.4H14.6667V13.6H9.33333V15H14.6667C15.402 15 16 14.3721 16 13.6V2.4C16 1.6279 15.402 1 14.6667 1H1.33333ZM0 6.6V8C3.44625 8 6.29079 10.7596 6.63281 14.285C6.65561 14.52 6.66667 14.7588 6.66667 15H8C8 10.3681 4.41133 6.6 0 6.6ZM0 9.4V10.8C2.206 10.8 4 12.6837 4 15H5.33333C5.33333 11.9123 2.94067 9.4 0 9.4ZM0 12.2V15H2.66667C2.66667 13.4537 1.47267 12.2 0 12.2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvChromecastStore);
export default __webpack_public_path__ + "static/media/ctv_chromecast_store.0de335b1f5b708fe5cf450238b373c02.svg";
export { ForwardRef as ReactComponent };